import React, { useContext } from "react";

import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Stack } from "@mui/system";

import { MonitoringCompany } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/monitoring_pb";

import { SnackbarContext } from "../../../../context/snackbar-context";
import ConfirmDialog from "../../../shared/confirm-dialog";
import { save } from "./monitoring-save";
import { SettingsContext } from "./settings-context";

const SettingsMonitoringConfirmDialog = () => {
  const theme = useTheme();
  const { showError } = useContext(SnackbarContext);
  const settingsContext = useContext(SettingsContext);
  const label =
    settingsContext.monitoringCompany === MonitoringCompany.ART_SECURITY
      ? settingsContext.monitoringCompanyOptions[2].label
      : settingsContext.monitoringCompany === MonitoringCompany.RAPIDSOS
      ? settingsContext.monitoringCompanyOptions[1].label
      : settingsContext.monitoringCompanyOptions[0].label;

  return (
    <ConfirmDialog
      title="Confirm Action"
      open={settingsContext.isOpenConfirmDialog}
      setOpen={settingsContext.setIsOpenConfirmDialog}
      onConfirm={() => {
        save(settingsContext, showError);
      }}
      onCancel={() => {
        settingsContext.setIsOpenConfirmDialog(false);
      }}
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Confirm"
    >
      {settingsContext.monitoringCompany !== MonitoringCompany.UNSPECIFIED ? (
        <Typography variant="body1" data-testid="enable-monitoring-message">
          Are you sure you want to enable <b>{label}</b> 24x7 monitoring?
        </Typography>
      ) : (
        <Stack direction="column" gap={1}>
          <Typography variant="body1" data-testid="disable-monitoring-message">
            Are you sure you want to disable 24x7 monitoring?
          </Typography>
          <Typography
            variant="body1"
            fontWeight={600}
            color={theme.palette.error.main}
          >
            All data will be lost!
          </Typography>
        </Stack>
      )}
    </ConfirmDialog>
  );
};

export default SettingsMonitoringConfirmDialog;
